import { AuthApi } from "../../api/Api";
import Login from "./Login";

new Login(
    (socialId) => AuthApi.socialLoginUri(socialId),
    (userId, accessToken, email, lastName) => ({
        userId: userId,
        accessToken: accessToken,
        email: email,
        lastName: lastName
    })
).init();


// WEBPACK FOOTER //
// ./js/page/login/LoginPage.js